import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { xor } from 'lodash';
import { sortListWithIds } from 'utils';
import { selectTopCategories } from '../../../../../../selectors';
import { useCatalogueContentSlice } from '../../../../hooks';
import { selectFilterModalState, selectSelectedFilterItems } from '../../../../selectors';

export const useFilterModal = () => {
	const { setSelectedFilterItems, closeModal } = useCatalogueContentSlice();

	const [isModalBtnsVisible, setIsModalBtnsVisible] = useState(false);

	const selectedFilterItems = useSelector(selectSelectedFilterItems);
	const topCategories = useSelector(selectTopCategories);
	const isModalOpen = useSelector(selectFilterModalState);

	const setSelectedItems = useCallback(
		(newSelectedItems: number[]) =>
			setSelectedFilterItems({
				selectedFilterItems: sortListWithIds(newSelectedItems, topCategories),
			}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[setSelectedFilterItems]
	);

	const [selectedFilterModalItems, setSelectedFilterModalItems] = useState<number[]>(
		selectedFilterItems
	);

	// обновляем набор выбранных элементов в фильтре при обновлении набора в сторе
	useEffect(() => {
		setSelectedFilterModalItems(selectedFilterItems);
	}, [selectedFilterItems]);

	//	определяем необходимость показывать кнопки сброса/применения выбранных элементов в модалке
	// показываем только при открытии модалки, если уже были выбраны элементы, либо если пользователь начал что-то менять
	useEffect(() => {
		if (
			selectedFilterModalItems.length - selectedFilterItems.length !== 0 ||
			selectedFilterItems.length !== 0
		) {
			setIsModalBtnsVisible(true);
		} else {
			setIsModalBtnsVisible(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedFilterModalItems]);

	useEffect(() => {
		if (!isModalOpen) {
			setSelectedFilterModalItems(selectedFilterItems);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isModalOpen]);

	const checkboxHandler = useCallback((categoryId: number) => {
		setSelectedFilterModalItems(prev => xor(prev, [categoryId]));
	}, []);

	const assignBtnHandler = useCallback(() => {
		setSelectedItems(selectedFilterModalItems);
		closeModal();
	}, [selectedFilterModalItems, setSelectedItems, closeModal]);

	const resetBtnHandler = useCallback(() => {
		setSelectedFilterModalItems([]);
	}, []);

	return {
		topCategories,
		selectedFilterModalItems,
		checkboxHandler,
		assignBtnHandler,
		resetBtnHandler,
		isModalBtnsVisible,
	};
};
